import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=06279c83&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=06279c83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06279c83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06279c83')) {
      api.createRecord('06279c83', component.options)
    } else {
      api.reload('06279c83', component.options)
    }
    module.hot.accept("./NoticeList.vue?vue&type=template&id=06279c83&scoped=true&", function () {
      api.rerender('06279c83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/NoticeList.vue"
export default component.exports